import { Injectable } from '@angular/core';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { AttestCommandHandler } from './attest-command-handler.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { InvoicePdfCommandHandler } from './invoice-pdf-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { RegisterPaymentCommandHandler } from './register-payment-command-handler.service';
import { SendCommandHandler } from './send-command-handler.service';
import { CreditInvoiceCommandHandler } from './credit-invoice-command-handler.service';
import { ReminderInvoiceCommandHandler } from './reminder-invoice-command-handler.service';
import { SetDefermentDateCommandHandler } from './set-deferment-date-command-handler.service';
import { DebtCollectionCommandHandler } from './debt-collection-command-handler.service';
import { RegulateFromBalanceCommandHandler } from './regulate-from-balance-command-handler.service';
import { CustomerLossCommandHandler } from './customer-loss-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { InvoicePdfWithRegulationsCommandHandler } from './invoice-pdf-with-regulations-command-handler.service';

@Injectable()
export class InvoiceFormCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    attestHandler: AttestCommandHandler,
    createInvoiceReminderHandler: ReminderInvoiceCommandHandler,
    creditHandler: CreditInvoiceCommandHandler,
    debtCollectionHandler: DebtCollectionCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    pdfHandler: InvoicePdfCommandHandler,
    pdfWithRegulationsHandler: InvoicePdfWithRegulationsCommandHandler,
    registerPaymentHandler: RegisterPaymentCommandHandler,
    regulateFromBalanceHandler: RegulateFromBalanceCommandHandler,
    sendHandler: SendCommandHandler,
    setDefermentDateHandler: SetDefermentDateCommandHandler,
    customerLossHandler: CustomerLossCommandHandler
  ) {
    super();
    this.addHandler(invoiceCommand.attest, attestHandler);
    this.addHandler(invoiceCommand.getpdf, pdfHandler);
    this.addHandler(invoiceCommand.getpdfWithRegulations, pdfWithRegulationsHandler);
    this.addHandler(invoiceCommand.credit, creditHandler);
    this.addHandler(invoiceCommand.customerLoss, customerLossHandler);
    this.addHandler(invoiceCommand.createReminder, createInvoiceReminderHandler);
    this.addHandler(invoiceCommand.debtCollection, debtCollectionHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(invoiceCommand.registerPayment, registerPaymentHandler);
    this.addHandler(invoiceCommand.regulateFromBalance, regulateFromBalanceHandler);
    this.addHandler(invoiceCommand.send, sendHandler);
    this.addHandler(invoiceCommand.setDefermentDate, setDefermentDateHandler);
  }
}
